import { memo } from 'react';

import { ACTION_TYPES } from 'ui/actions/action-config';
import { showActionSidebar } from 'ui/traveller-journey-builder/action-sidebar';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { JourneyStart } from './common';

const ACTION_TYPE = ACTION_TYPES.journey_start;

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node} hideTargetHandle disableClick>
      <JourneyStart node={node} cursor="pointer" onIconClick={() => showActionSidebar(node)} />
    </NodeContainer>
  );
});
